export default "__VITE_ASSET__Ds89pY3l__"